module.exports = __webpack_public_path__ + "img/arrowRight.d0672d38.svg";